import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function fetchBlogPosts(options = {}) {
  return function withContext(context) {
    const { skip = 0, take = 10, tag } = options;
    const params = new URLSearchParams({ skip, take });

    if (tag) {
      params.set('tag', tag);
    }

    const url = `${API_URL}blog/posts?${params.toString()}`;

    return _fetch(url, { withAuth: false }, { method: 'GET' })(context);
  };
}
